import transport from "../../../mixins/transport";

export default {
  mixins: [transport],
  props: {
    data: {
      type: Object,
      required: true,
    },
    blocks: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      rules:{
        required: (v) => (v && (v.length>0))  || "Необходимо заполнить",
        max8kb: (v) => !v || v.length <= 65535 || "Достигнут максимальный размер"
      },
      override: {}
    };
  },
  methods: {
    save(baseData) {
      if (this.loading) return;
      const payload = Object.assign(
        {},
        baseData,
        this.override
      );
      this.exchange(
        (data) => {
          this.$emit("update", data);
        },
        payload,
        "news/block/save",
        'POST',
        'Сохранено'
      );
    }
  }
};
